import AFM from '../assets/images/workshops/AFM.png';
import ALD from '../assets/images/workshops/ALD.png';
import Raman from '../assets/images/workshops/Raman.png';
import Elipmetry from '../assets/images/workshops/ELIPSOMETRIA.png';
import Energy from '../assets/images/workshops/nanomaterials for energy storage.png';
import Modeling from '../assets/images/workshops/nanomaterials modeling.png';
import Ferroelectric from '../assets/images/workshops/Ferroelectric.png';
import Luminescent from '../assets/images/workshops/Luminescent Materials for Nanomedicine Applications.png';
import Protein from '../assets/images/workshops/Protein Engineering for Electrochemical Biosensors.png';
import Recombination from '../assets/images/workshops/Recombinant Proteins and DLS The Essentials.png';


export const WorkshopsList = [
    {
        id: 1,
        title: "Atomic Force Microscopy (AFM)",
        leader: "Dr. Eduardo Murillo",
        description: "The Atomic Force Microscopy (AFM) Workshop is designed to provide participants with a comprehensive understanding of the physical principles, operational modes, and advanced applications of this nanoscale characterization technique. Through both theoretical and practical sessions, attendees will learn how to prepare samples, select appropriate probes, optimize scanning parameters, and analyze topographic, phase, and force images. The workshop aims to strengthen the technical skills required for research in nanoscience, solid-state physics, materials science, biotechnology, and related fields. By the end of the training, participants will be able to operate an AFM system independently, interpret results, and apply the technique to solve experimental problems within their research projects.",
        modules: [
            {
                number: 1,
                title: "Introduction to AFM",
                topics: [
                    "History and evolution of AFM",
                    "Tip–sample interaction basic concepts",
                    "Comparison: AFM vs SEM/TEM vs STM"
                ]
            },
            {
                number: 2,
                title: "Operating Principles",
                topics: [
                    "Interatomic and Van der Waals forces",
                    "Cantilever mechanical properties and spring constant",
                    "Laser deflection and quadrant photodiode detection",
                    "Feedback modes: contact, non-contact, tapping"
                ]
            },
            {
                number: 3,
                title: "Imaging Modes and Advanced Techniques",
                topics: [
                    "Contact, Non-contact, Tapping modes",
                    "Phase imaging",
                    "Force–distance curves and adhesion",
                    "Advanced: MFM, KPFM, EFM, Conductive-AFM"
                ]
            },
            {
                number: 4,
                title: "Sample Preparation",
                topics: [
                    "Substrate cleaning (Si, glass, polymers)",
                    "Preparation of nanoparticles and thin films"
                ]
            },
            {
                number: 5,
                title: "Scanning Parameters and Instrument Operation",
                topics: [
                    "Probe selection and coatings",
                    "Scan configuration: speed, lines per second, setpoint",
                    "Noise, vibration and environmental control"
                ]
            },
            {
                number: 6,
                title: "Image Processing and Analysis",
                topics: [
                    "Leveling, filtering, noise removal",
                    "Roughness analysis (Rq, RMS, Ra)",
                    "Line profiles and topography evaluation"
                ]
            },
            {
                number: 7,
                title: "AFM Applications",
                topics: [
                    "Thin films and nanostructures",
                    "Magnetic and semiconductor nanoparticles",
                    "Soft materials, polymers, hydrogels"
                ]
            },
            {
                number: 8,
                title: "Practical Session",
                topics: [
                    "Hands-on AFM operation and data acquisition"
                ]
            }
        ],
        img: AFM
    },
    {
        id: 2,
        title: "Atomic Layer Deposition (ALD)",
        leader: "Dr. Hugo Tiznado, Dr. Javier Lopez",
        description: "The Atomic Layer Deposition (ALD) Workshop is designed to provide students, technicians, and research personnel with an in-depth understanding of the fundamentals, capabilities, and applications of this advanced thin-film growth technique. ALD is distinguished by its atomic-level thickness control, excellent uniformity, and high conformality, making it an essential tool for the fabrication of nanostructures, electronic devices, photonic coatings, catalysts, and functional interfaces. Through theoretical and practical sessions, participants will learn the chemical principles of the process, surface self-limiting mechanisms, recipe development, precursor handling, safe equipment operation, and the characterization of the resulting films. By the end of the workshop, attendees will be able to understand, execute, and interpret ALD processes, as well as integrate this method into their research or technological development projects.",
        modules: [
            {
                number: 1,
                title: "Introduction to ALD",
                topics: [
                    "History and evolution",
                    "Differences ALD vs CVD/PVD",
                    "Applications in electronics, photonics, energy"
                ]
            },
            {
                number: 2,
                title: "Fundamentals of the ALD Process",
                topics: [
                    "ALD cycles: pulse–purge",
                    "Self-limiting surface reactions",
                    "Temperature windows and kinetics"
                ]
            },
            {
                number: 3,
                title: "Precursors and Reactants",
                topics: [
                    "Metal precursors and common reactants",
                    "Stability, reactivity and safety"
                ]
            },
            {
                number: 4,
                title: "Process Design and Optimization",
                topics: [
                    "Recipe development",
                    "Thickness control and growth per cycle",
                    "Multilayers and heterostructures"
                ]
            },
            {
                number: 5,
                title: "Characterization of ALD Thin Films",
                topics: [
                    "Ellipsometry, AFM, XRD, XPS, UV–Vis, SEM/TEM"
                ]
            },
            {
                number: 6,
                title: "Applications",
                topics: [
                    "Barrier coatings, photocatalytic nanostructures, electrodes for batteries"
                ]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: [
                    "Hands-on ALD recipes and film characterization"
                ]
            }
        ],
        img: ALD
    },
    {
        id: 3,
        title: "Raman Spectroscopy",
        leader: "Dra. Yasmin Esqueda",
        description: "The Raman Spectroscopy Workshop is designed to provide students, instructors, technicians, and researchers with a solid understanding of the physical principles, instrumentation, and practical applications of this vibrational technique. Raman spectroscopy enables the identification of crystalline phases, the study of chemical bonds, the characterization of nanostructured materials, the analysis of internal stresses, and the evaluation of degradation processes or chemical reactivity—making it an essential tool in materials science, chemistry, biology, and nanotechnology. Throughout the workshop, participants will explore the theoretical foundations of the Raman effect, learn to interpret spectra, understand the differences between conventional Raman, micro-Raman, and enhanced techniques, and develop skills for proper sample preparation and measurement. During the practical sessions, they will operate a Raman system, adjust instrumental parameters, acquire reliable spectra, and apply both quantitative and qualitative analysis techniques. By the end of the workshop, attendees will be able to operate a Raman spectrometer, interpret spectra, and apply the technique to research involving inorganic materials, biomolecules, polymers, semiconductors, nanoparticles, and functionalized surfaces.\n",
        modules: [
            {
                number: 1,
                title: "Introduction to Raman Spectroscopy",
                topics: ["History, fundamentals, differences Raman vs FTIR"]
            },
            {
                number: 2,
                title: "Vibrational Fundamentals",
                topics: ["Normal modes, Raman selection rule, Raman shift"]
            },
            {
                number: 3,
                title: "Raman Instrumentation",
                topics: ["Laser selection, microscope objectives, detectors, alignment and safety"]
            },
            {
                number: 4,
                title: "Advanced Raman Techniques",
                topics: ["Micro-Raman, Raman mapping, Confocal, SERS"]
            },
            {
                number: 5,
                title: "Sample Preparation",
                topics: ["Solid, liquid, polymer considerations; thermal effects and fluorescence"]
            },
            {
                number: 6,
                title: "Spectral Acquisition",
                topics: ["Laser power, acquisition time, resolution, signal/noise strategies"]
            },
            {
                number: 7,
                title: "Data Processing and Analysis",
                topics: ["Baseline correction, smoothing, band assignment, multivariate analysis"]
            },
            {
                number: 8,
                title: "Applications",
                topics: ["Semiconductors, nanoparticles, polymers, biomaterials, ALD coatings"]
            },
            {
                number: 9,
                title: "Practical Session",
                topics: ["Hands-on Raman operation and spectrum interpretation"]
            }
        ],
        img: Raman
    },
    {
        id: 4,
        title: "Spectroscopic Ellipsometry",
        leader: "Dra. Noemi Abundiz",
        description: "The Spectroscopic Ellipsometry Workshop is designed to provide students, technicians, instructors, and researchers with a solid foundation in the optical principles, instrumentation, and analytical applications of this powerful characterization technique. Spectroscopic ellipsometry enables the precise determination of film thickness, refractive index, extinction coefficient, and optical properties of thin films, multilayers, oxides, semiconductors, and nanostructured materials. Through a combination of theoretical and practical sessions, participants will learn how polarized light interacts with matter, how to select appropriate optical models, how to adjust experimental parameters, and how to perform data analysis using specialized software. During the hands-on sessions, participants will operate an ellipsometer, acquire full spectra, build models (Cauchy, Tauc–Lorentz, Drude–Lorentz, EMA, multilayers), and evaluate fit quality using metrics such as MSE (Mean Square Error). By the end of the workshop, attendees will be able to measure thin films, create reliable optical models, interpret spectra, and apply the technique in their research involving photonics, semiconductors, and functional coatings.\n",
        modules: [
            {
                number: 1,
                title: "Introduction to Ellipsometry",
                topics: ["Fundamentals, light polarization, advantages and limitations"]
            },
            {
                number: 2,
                title: "Physical Principles",
                topics: ["Psi and Delta, Fresnel equations, thin-film optics"]
            },
            {
                number: 3,
                title: "Instrumentation",
                topics: ["Components, measurement geometry, calibration"]
            },
            {
                number: 4,
                title: "Optical Modeling",
                topics: ["Cauchy, Tauc–Lorentz, Drude models, EMA, multilayers"]
            },
            {
                number: 5,
                title: "Sample Preparation",
                topics: ["Substrate considerations, cleaning, handling sensitive samples"]
            },
            {
                number: 6,
                title: "Practical Session",
                topics: ["Hands-on ellipsometer measurements and model fitting"]
            }
        ],
        img: Elipmetry
    },
    {
        id: 5,
        title: "Nanomaterials for Energy Storage",
        leader: "Dra. Ana Karina Cuentas, Dra. Perla Perez Diaz",
        description: "The Nanomaterials for Energy Storage workshop provides a structured introduction to the fundamental principles governing electrochemical energy storage and the critical role of nanomaterials in modern batteries and supercapacitors. The workshop begins with the basic concepts of energy storage and redox reactions, followed by an integrated discussion of electrochemical charge-storage mechanisms and key characterization techniques, including cyclic voltammetry, galvanostatic charge–discharge, and electrochemical impedance spectroscopy. Participants will learn how to interpret electrochemical data to distinguish between capacitive, pseudocapacitive, and battery-type behavior. The workshop then examines the origin of nanomaterial properties and their classification, highlighting carbon materials, metal oxides, conducting polymers, and two-dimensional systems. Finally, practical aspects of electrode fabrication, structure–performance relationships, and applications in batteries and supercapacitors are addressed, along with current challenges related to scalability and sustainability. By the end of the workshop, participants will be able to critically evaluate nanomaterials and electrochemical data for the design of next-generation energy storage devices.",
        modules: [
            {
                number: 1,
                title: "Fundamentals of Electrochemical Energy Storage",
                topics: ["Energy density vs power density, Ragone plot, redox basics"]
            },
            {
                number: 2,
                title: "Electrochemical Storage Mechanisms and Characterization",
                topics: ["CV, GCD, EIS; faradaic vs non-faradaic; kinetic limitations"]
            },
            {
                number: 3,
                title: "Nanomaterials: Origin of Properties and Classification",
                topics: ["Carbon materials, metal oxides, conducting polymers, 2D materials"]
            },
            {
                number: 4,
                title: "Nanomaterials in Batteries and Supercapacitors",
                topics: ["Lithium-ion, sodium-ion, role in anodes/cathodes, challenges"]
            },
            {
                number: 5,
                title: "From Nanomaterials to Devices: Fabrication and Design",
                topics: ["Electrode fabrication, slurry formulation, scaling challenges"]
            },
            {
                number: 6,
                title: "Applications, Recycling, Sustainability",
                topics: ["Recycling, green synthesis, emerging trends"]
            }
        ],
        img: Energy
    },
    {
        id: 6,
        title: "Nanomaterials Modeling",
        leader: "Dr. Jonathan Guerrero",
        description: "The Nanomaterials Modeling by DFT (Density Functional Theory) Workshop is designed to introduce students, instructors, and researchers to the use of first-principles methods for the theoretical study of materials at the nanoscale. Density Functional Theory (DFT) is one of the most powerful computational tools for predicting structural, electronic, magnetic, optical, and energetic properties of material systems without relying on empirical parameters. It enables the understanding of atomic-level mechanisms governing the behavior of nanostructures, monolayers, surfaces, defects, and advanced functional materials. Throughout the workshop, participants will learn the fundamentals of quantum mechanics applied to materials, the formulation of DFT, exchange–correlation functional approximations, the construction of crystalline and nanostructured systems, as well as the setup of calculations using specialized software. Essential techniques such as geometric optimization, electronic band structure calculations, density of states (DOS/PDOS), magnetic properties, defect energetics, molecular adsorption, and stability analysis will be addressed. In the practical sessions, attendees will learn how to set up calculations using different software packages, run simulations, analyze results, and build solid scientific reports. By the end of the workshop, participants will be able to apply DFT to the modeling of metallic, oxide, semiconductor, two-dimensional materials, heterostructures, and functional surfaces.",
        modules: [
            {
                number: 1,
                title: "Introduction to Computational Modeling",
                topics: ["Qué es DFT, relación teoría-experimento, escalas de modelado"]
            },
            {
                number: 2,
                title: "Theoretical Foundations of DFT",
                topics: ["Schrödinger, Kohn–Sham, exchange–correlation functionals"]
            },
            {
                number: 3,
                title: "Construction of Systems and Nanostructures",
                topics: ["Unit cells, surfaces, defects, adsorption"]
            },
            {
                number: 4,
                title: "Preparing DFT Calculations",
                topics: ["Pseudopotentials, cutoffs, k-point meshes, convergence"]
            },
            {
                number: 5,
                title: "Properties Obtainable with DFT",
                topics: ["Band structure, DOS/PDOS, magnetic properties, adsorption energies"]
            },
            {
                number: 6,
                title: "Practical Simulation Tools",
                topics: ["VASP/Quantum ESPRESSO input, running on clusters, visualization"]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: ["Hands-on DFT setup and result analysis"]
            }
        ],
        img: Modeling
    },
    {
        id: 7,
        title: "Ferroelectric Materials",
        leader: "Dr. Subhash Sharma, Dra. H'Linh Hmok ",
        description: "The Ferroelectric Materials Workshop is designed to provide students, instructors, technicians, and researchers with a solid foundation in the fundamentals, properties, synthesis, characterization, and technological applications of ferroelectric materials. These materials exhibit spontaneous electric polarization that can be reversed by applying an electric field, making them essential components for non-volatile memories, sensors, actuators, transducers, piezoelectric devices, ferroelectric photovoltaics, and emerging technologies such as memristors and neuromorphic systems. Throughout the workshop, participants will explore ferroelectric crystal structures, polarization mechanisms, electric domains, phase transitions, and the structure–property relationships at the micro- and nanoscale. Various synthesis routes for both ceramic materials and thin films (sol–gel, sputtering, ALD, MOCVD) will be addressed, as well as advanced dielectric, piezoelectric, and structural characterization techniques (XRD, P–E loops, AFM–PFM, Raman). During the practical sessions, attendees will learn how to prepare samples, measure P–E hysteresis loops, perform impedance spectroscopy, identify domains using PFM, and analyze how microstructural factors influence material performance. By the end of the workshop, participants will be able to understand, evaluate, and apply ferroelectric materials across various scientific and technological fields.\n",
        modules: [
            {
                number: 1,
                title: "Introduction to Ferroelectric Materials",
                topics: ["Ferroelectricity, piezoelectricity, pyroelectricity, aplicaciones"]
            },
            {
                number: 2,
                title: "Ferroelectric Structures and Mechanisms",
                topics: ["Perovskites, domains, phase transitions"]
            },
            {
                number: 3,
                title: "Synthesis of Ferroelectric Materials",
                topics: ["Ceramics, thin films, sol–gel, sputtering, MOCVD"]
            },
            {
                number: 4,
                title: "Electrical and Functional Characterization",
                topics: ["P–E loops, dielectric properties, piezoelectric coefficients"]
            },
            {
                number: 5,
                title: "Advanced Ferroelectric Materials",
                topics: ["Doped HfO2, multiferroics, 2D ferroelectrics"]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: ["Hands-on sample prep and measurement (PFM, hysteresis)"]
            }
        ],
        img: Ferroelectric
    },
    {
        id: 8,
        title: "Luminescent Materials for Nanomedicine Applications",
        leader: "Dr. Gustavo Hirata y Dr. Prakhar",
        description: "The Luminescent Materials for Nanomedicine Applications Workshop is designed to provide students, researchers, and specialized technicians with comprehensive training on the optical principles, synthesis, surface functionalization, and biomedical applications of luminescent nanomaterials. These materials —including quantum dots, lanthanide-doped nanoparticles, NV nanodiamonds, perovskite nanoparticles, upconversion nanoparticles (UCNPs), and organic fluorescent probes— play an essential role in advanced medical diagnostics, bioimaging, controlled drug delivery, photodynamic therapy, sensing, and personalized nanomedicine. The workshop combines theoretical foundations with hands-on sessions to deepen understanding of luminescence mechanisms, energy transfer processes, material selection according to biomedical applications, bioconjugation strategies, biological compatibility, and optical characterization (PL, lifetime, UV–Vis, NIR). Participants will learn to correlate structure, composition, and optical response with performance in nano–bio interactions, including colloidal stability, cellular internalization, and sensitivity to physiological environments. By the end of the workshop, attendees will be able to understand, select, synthesize, and evaluate luminescent materials for nanomedicine applications, enabling their use in multicolor bioimaging, theranostics, optical sensing, light-assisted therapies, and advanced nanotechnology platforms.",
        modules: [
            {
                number: 1,
                title: "Introduction to Luminescent Materials",
                topics: ["Fundamentos de fluorescencia y fosforescencia, selección de materiales"]
            },
            {
                number: 2,
                title: "Classes of Luminescent Materials",
                topics: ["Quantum dots, lanthanide-doped, UCNPs, nanodiamonds, perovskites"]
            },
            {
                number: 3,
                title: "Synthesis and Surface Functionalization",
                topics: ["Solvothermal, hot-injection, coatings, bioconjugation"]
            },
            {
                number: 4,
                title: "Optical Mechanisms",
                topics: ["FRET/LRET, upconversion, photobleaching, lifetimes"]
            },
            {
                number: 5,
                title: "Applications in Nanomedicine",
                topics: ["Bioimaging, theranostics, optical sensors, PDT/PTT"]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: ["Hands-on synthesis and optical characterization"]
            }
        ],
        img: Luminescent
    },
    {
        id: 9,
        title: "Protein Engineering for Electrochemical Biosensors",
        leader: "Dr. Andres Zarate",
        description: "The Protein Engineering for Electrochemical Biosensors Workshop is designed to provide students, technicians, and researchers with comprehensive training in the design, modification, and application of proteins as recognition elements in electrochemical biosensors. Protein engineering—through directed mutagenesis, fusion domains, functional tags, and structural optimization—enables the creation of highly specific, stable, and sensitive bioreceptors capable of detecting clinically, environmentally, nutritionally, and pharmaceutically relevant analytes.  Throughout the workshop, participants will explore how the structural properties of proteins (affinity, stability, conformational mobility, isoelectric point, surface charge distribution) influence their performance when immobilized onto electrodes and integrated into electrochemical platforms. Fundamental techniques such as cyclic voltammetry, electrochemical impedance spectroscopy (EIS), chronoamperometry, and both chemical and physical immobilization methods (SAMs, covalent binding, affinity interactions, nanomaterial-based matrices) will be addressed.\n" +
            " \n" +
            "The workshop integrates theoretical and practical components covering protein modification, mutant selection, sensor design, electrode functionalization, and electrochemical characterization. By the end of the training, participants will be able to engineer specific proteins for biosensor applications, immobilize them effectively, and evaluate their electrochemical performance, integrating concepts from molecular biology, electrochemistry, and nanomaterials.\n",
        modules: [
            {
                number: 1,
                title: "Introduction to Electrochemical Biosensors",
                topics: ["Conceptos básicos, componentes bioreceptor-transductor-señal"]
            },
            {
                number: 2,
                title: "Fundamentals of Protein Engineering",
                topics: ["Mutagénesis, diseño racional, dominios de fusión y etiquetas"]
            },
            {
                number: 3,
                title: "Proteins as Bioreceptors",
                topics: ["Anticuerpos, scFv, nanobodies, enzimas y aptámeros"]
            },
            {
                number: 4,
                title: "Protein Immobilization on Electrodes",
                topics: ["SAMs, covalent bonding, His-tag, biotin–streptavidin, nanomaterial supports"]
            },
            {
                number: 5,
                title: "Applied Electrochemical Techniques",
                topics: ["CV, EIS, chronoamperometry, pulse voltammetry"]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: ["Fabricación de sensores y caracterización electroquímica"]
            }
        ],
        img: Protein
    },
    {
        id: 10,
        title: "Recombinant Proteins and DLS: The Essentials",
        leader: "Dr. Mauricio A. Trujillo, Dr. Ruben Dario Cadena Navay, Dra. Norma Adriana Valdez Cruz",
        description: "The Recombinant Proteins and DLS: The Essentials Workshop is designed to provide comprehensive, clear, and application-oriented training on recombinant protein production and their biophysical characterization using Dynamic Light Scattering (DLS). Both methodologies are fundamental tools in modern biotechnology, biomedical research, bioengineering, biopharmaceutical development, nanomedicine, and structural analysis of biomolecules. Throughout the workshop, participants will explore the essential principles of genetic engineering, vector construction, host selection, and the most common strategies for recombinant protein expression and purification. In parallel, they will learn the theoretical and experimental foundations of DLS as a technique for determining the hydrodynamic size, polydispersity, aggregation state, and colloidal stability of proteins in solution.\n" +
            " \n" +
            "The theoretical sessions will be complemented by guided practical activities focused on proper sample preparation, correct execution of DLS measurements, interpretation of intensity/volume/number distributions, and evaluation of protein aggregation. By the end of the workshop, attendees will be able to produce recombinant proteins, assess their quality using DLS, and apply both approaches in research and technological development.  The workshop aims to provide a solid, practical understanding of recombinant protein production and the use of DLS for their characterization, equipping participants with the theoretical and practical foundations to analyze their structural integrity, stability, and aggregation.\n",
        modules: [
            {
                number: 1,
                title: "Introduction to Recombinant Proteins",
                topics: ["Conceptos de ADN recombinante, vectores, sistemas de expresión"]
            },
            {
                number: 2,
                title: "Production and Purification",
                topics: ["Transformación, cultivo, purificación cromatográfica, SDS-PAGE"]
            },
            {
                number: 3,
                title: "Fundamentals of DLS",
                topics: ["Brownian motion, hydrodynamic diameter, PDI, distributions"]
            },
            {
                number: 4,
                title: "Sample Preparation for DLS",
                topics: ["Concentración, filtración, buffers y prevención de agregación"]
            },
            {
                number: 5,
                title: "DLS Data Acquisition and Interpretation",
                topics: ["Instrument setup, identification of aggregates, reporting"]
            },
            {
                number: 7,
                title: "Practical Session",
                topics: ["Producción de proteína y mediciones DLS prácticas"]
            }
        ],
        img: Recombination
    }
];

export default WorkshopsList;
